import { Map } from 'immutable';

import { getInventoryOperationValue } from '../../../product/getOperationValue';

import { OPERATIONS, WEIGHT_OPERATIONS } from '../../../../constants/bulkEdit';
import { EBAY, ETSY, FAIRE } from '../../../../constants/channels';
import { ATTRIBUTE } from '../../../../constants/attributes';

export function shippingWeight({ channel, preview }) {
  switch (channel) {
    case EBAY: {
      const payload = [];
      const operation = preview.getIn([ATTRIBUTE.SHIPPING, 'operation']);

      if (preview.hasIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR])) {
        payload.push(
          Map({
            type: WEIGHT_OPERATIONS[operation][ATTRIBUTE.WEIGHT_MAJOR],
            value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR]),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT_MINOR])) {
        payload.push(
          Map({
            type: WEIGHT_OPERATIONS[operation][ATTRIBUTE.WEIGHT_MINOR],
            value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT_MINOR]),
          })
        );
      }

      return { payload };
    }

    case ETSY: {
      return {
        payload: Map({
          type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
          value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT]),
        }),
      };
    }

    case FAIRE: {
      const payload = [];

      if (preview.hasIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT])) {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
            value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.WEIGHT]),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.MASS_UNIT])) {
        payload.push(
          Map({
            type: OPERATIONS[FAIRE].MASS_UNIT,
            value: getInventoryOperationValue({
              channel,
              type: ATTRIBUTE.MASS_UNIT,
              value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.MASS_UNIT]),
            }),
          })
        );
      }

      return { payload };
    }

    default: {
      return {};
    }
  }
}
